import Result from "../types/result";
import { getPostHeaders } from "./request";
import { parseResponse } from "./response";

interface QueryParams {
  [key: string]: string | number | boolean | string[] | number[] | boolean[] | undefined;
}

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonValue[]
  | {
      [key: string]: JsonValue;
    };

const createSearchParams = (queryParams: QueryParams): string => {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, String(item)));
    } else {
      params.append(key, String(value));
    }
  });

  // Only return "?" if there are any params to append, otherwise return "
  return params.toString() ? `?${params}` : "";
};

async function patch<T>(url: string, queryParams: QueryParams = {}, bodyParams: JsonValue = {}): Promise<Result<T>> {
  const requestOptions = {
    method: "PATCH",
    headers: await getPostHeaders(),
    body: JSON.stringify(bodyParams)
  };

  const urlParams = createSearchParams(queryParams);
  const response = await fetch(url + urlParams, requestOptions);
  const result = await parseResponse<T>(response);
  return result;
}

export default patch;
